import { makeStyles } from '@material-ui/core'
import { useFormContext } from 'react-hook-form'

import helpers from 'helpers'

const styles = ({ isCompact, isMobile, isFixed, isFull }) =>
  makeStyles(() => {
    const { watch } = useFormContext()
    const {
      fontFamily,
      secondaryColor,
      calculatedSecondaryColor,
      secondaryBGColor,
    } = helpers.cookies.banner.getStyleTokens(watch)

    const minHeight = () => {
      if (isMobile && isFixed) return 42
      if (isCompact) return 32
      return isMobile ? 38 : 36
    }

    const choiceButton = {
      paddingTop: isCompact ? 7 : 8,
      paddingBottom: isCompact ? 7 : 8,
      ...(isMobile && {
        flex: '0 1 120px',
        width: 'auto',
        paddingLeft: isCompact || isFixed ? 8 : 4,
        paddingRight: isCompact || isFixed ? 8 : 4,
      }),
    }

    return {
      button: {
        fontFamily: fontFamily,
        fontSize: isCompact ? 12 : 14,
        width: '100%',
        maxWidth: isFull || isCompact || isMobile ? 'none' : 196,
        minWidth: isFull || isMobile ? 0 : 64,
        flex: isFull ? 'none' : isCompact ? '1 1 0' : undefined,
        minHeight: minHeight(),
        padding: isCompact ? '5px 12px' : '6px 16px',
        border: '1px solid transparent',
        borderRadius: 8,
        whiteSpace: 'nowrap',
        '& > span': {
          display: 'block',
          fontWeight: 400,
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          textAlign: 'center',
        },
      },
      settingsButton: {
        textTransform: 'initial',
        letterSpacing: 'normal',
        color: secondaryColor,
        border: 0,
        ...(isFull &&
          !isCompact && {
            paddingLeft: 0,
            paddingRight: 0,
          }),
        ...(!isFull && {
          flex: isMobile ? '0 0 auto' : '0 1 auto',
          width: 'auto',
          maxWidth: '33%',
          marginRight: 'auto',
          paddingLeft: 0,
          paddingRight: 0,
          justifyContent: 'flex-start',
          '& > span': {
            textAlign: 'left',
          },
        }),
        '&:hover': {
          backgroundColor: 'transparent',
        },
      },
      rejectButton: {
        ...choiceButton,
        boxShadow: 'none',
        color: secondaryColor,
        borderColor: calculatedSecondaryColor?.light,
        '&:hover': {
          borderColor: calculatedSecondaryColor?.dark,
          backgroundColor: secondaryBGColor,
        },
      },
      acceptButton: {
        ...choiceButton,
        backgroundColor: secondaryColor,
        color: calculatedSecondaryColor?.contrastText,
        '&:hover': {
          backgroundColor: calculatedSecondaryColor?.dark,
        },
      },
    }
  })

export default styles
